import React from 'react'
import { Flex, Tooltip } from '@radix-ui/themes'
import cn from 'classnames'
import { CupIcon } from 'shared/icons'
import { SeasonBonus } from '../constants/season-bonuses'
import styles from '../rewards.module.scss'

interface Props {
  /** Completed challenges of the season. */
  currentStep: number
  /** The milestone of this cup. */
  bonus: SeasonBonus
  /** Challenges of the season. */
  totalSteps: number
  padding: '1' | '2' | '3'
}

/** `Earn 500 points for completing 2 of 7 challenges` (or all of them). */
export const getSeasonBonusText = (
  { countCompleted, points }: SeasonBonus,
  totalSteps: number
) =>
  countCompleted >= totalSteps ?
    `Earn ${points} points for completing all ${totalSteps} challenges`
  : `Earn ${points} points for completing ${countCompleted} of ${totalSteps} challenges`

export const RewardsProgressBarTooltip: React.FC<Props> = ({
  currentStep,
  bonus,
  totalSteps,
  padding
}) => {
  const tooltipText = getSeasonBonusText(bonus, totalSteps)

  return (
    <Tooltip
      content={tooltipText}
      className={styles.tooltip}
      delayDuration={100}
    >
      <Flex
        align={'center'}
        justify={'center'}
        p={padding}
        role='img'
        aria-label={tooltipText}
        className={cn(
          styles.statisticsIconContainer,
          styles.cupContainer,
          'cursor-pointer',
          {
            [styles.progressBarStepActive]: currentStep >= bonus.countCompleted
          }
        )}
      >
        <CupIcon color='var(--black)' />
      </Flex>
    </Tooltip>
  )
}
